import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const CarDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [carDetails, setCarDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCarDetails = async () => {
    setLoading(true);

    setError(null);

    try {
      const response = await axios.get(
        `http://192.168.29.147:5000/api/global/user/get-car/${id}`
      );
      console.log(response);

      setCarDetails(response.data.data);
    } catch (err) {
      console.log(err);

      setError("Failed to fetch car details. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCarDetails();
  }, [id]);

  const handleTestDriveClick = () => {
    const isLoggedin = localStorage.getItem("userToken");

    if (isLoggedin) {
      navigate(`/booking/add/${id}`);
      
    } else {
      navigate("/user-login");
    }
  };

  if (loading) return <p>Loading car details...</p>;
  if (error) return <p className="text-red-500">{error}</p>;
  if (!carDetails) return null;

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-6xl mx-auto p-4 grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="space-y-4">
          <div className="relative overflow-hidden rounded-xl shadow-lg">
            <img
              src={carDetails.images[0] || "https://placehold.co/600x400"} // Use the first image or a placeholder
              alt={`${carDetails.brand} ${carDetails.model}`}
              className="w-full h-auto object-cover"
              loading="lazy"
            />
            <div className="absolute bottom-4 right-4 bg-amber-500 text-white px-3 py-1 rounded-full text-sm font-medium">
              {carDetails.rating || "N/A"} ★
            </div>
          </div>

          <div className="grid grid-cols-4 gap-2">
            {carDetails.images.slice(1, 5).map((image, index) => (
              <div
                key={index}
                className="aspect-square overflow-hidden rounded-lg border border-gray-200"
              >
                <img
                  src={
                    image || "https://placehold.co/150?text=Image+Placeholder"
                  }
                  alt={`Additional view ${index + 1} of ${carDetails.brand} ${
                    carDetails.model
                  }`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="space-y-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">
              <span className="text-amber-500">{carDetails.brand}</span>{" "}
              {carDetails.model}
            </h1>
            <div className="flex items-center gap-2 mt-2">
              <span className="text-gray-600">{carDetails.year}</span>
              <span className="w-1 h-1 rounded-full bg-gray-400"></span>
              <span className="text-gray-600">{carDetails.fuelType}</span>
              <span className="w-1 h-1 rounded-full bg-gray-400"></span>
              <span className="text-gray-600">{carDetails.transmission}</span>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <div className="flex justify-between items-center">
              <div>
                <p className="text-gray-500">Price</p>
                <p className="text-3xl font-bold text-amber-500">
                  {carDetails.price}
                </p>
                <p className="text-sm text-gray-500 mt-1">
                  EMI starts at ₹19,999/mo
                </p>
              </div>
              <button
                onClick={handleTestDriveClick}
                className="bg-amber-500 hover:bg-amber-600 text-white px-6 py-3 rounded-lg font-medium shadow-md"
              >
                Book Test Drive
              </button>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm grid grid-cols-2 gap-4">
            <div>
              <p className="text-gray-500 text-sm">Mileage</p>
              <p className="text-lg font-semibold text-amber-500">
                {carDetails.mileage}
              </p>
            </div>
            <div>
              <p className="text-gray-500 text-sm">Fuel Type</p>
              <p className="text-lg font-semibold text-amber-500">
                {carDetails.fuelType}
              </p>
            </div>
            <div>
              <p className="text-gray-500 text-sm">Transmission</p>
              <p className="text-lg font-semibold text-amber-500">
                {carDetails.transmission}
              </p>
            </div>
            <div>
              <p className="text-gray-500 text-sm">Rating</p>
              <p className="text-lg font-semibold text-amber-500">
                {carDetails.rating} ★
              </p>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm">
            <h2 className="text-xl font-semibold text-amber-500 mb-4">
              Features
            </h2>
            <div className="grid grid-cols-2 gap-3">
              {carDetails.features && carDetails.features.length > 0 ? (
                carDetails.features.map((feature, index) => (
                  <div key={index} className="flex items-start">
                    <svg
                      className="w-5 h-5 text-amber-500 mr-2 mt-0.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 13l4 4L19 7"
                      ></path>
                    </svg>
                    <span>{feature}</span>
                  </div>
                ))
              ) : (
                <p>No features available.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarDetailsPage;
